import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../redux/authSlice";
import adminAvatar from "/images/admin-avatar.png";
import malerAvatar from "/images/male-avatar.png";
import femaleAvatar from "/images/female-avatar.png";
import { useIsMobile } from "../hooks/useIsMobile";
import { authAxios } from "../utils/axiosConfig";
import { ROUTES } from "../router/appRoutes";

const ProfileMenu = ({ isMobileMenuOpen, className }) => {
	const [isOpen, setIsOpen] = useState(false);
	const { role, gender, firstname, lastname } = useSelector(
		(state) => state.auth
	);
	const dropdownRef = useRef(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isMobile = useIsMobile();

	const toggleMenu = () => setIsOpen((prevIsOpen) => !prevIsOpen);

	const handleClickOutside = (e) => {
		if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		// Add event listener when component mounts
		document.addEventListener("mousedown", handleClickOutside);

		// Clean up the event listener when component unmounts
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleProfile = () => {
		// toggleMenu();
		navigate(ROUTES.DASHBOARD);
	};
	const handleProfileMobile = () => {
		toggleMenu();
		isMobileMenuOpen((open) => !open);
		className("hamburger_close");
		navigate("/profile");
	};

	const handleUsers = () => {
		toggleMenu();
		navigate("/users");
	};
	const handleUsersMobile = () => {
		toggleMenu();
		isMobileMenuOpen(false);
		className("hamburger_close");
		navigate("/users");
	};

	const handleAddUser = () => {
		toggleMenu();
		navigate("/signup");
	};
	const handleAddUserMobile = () => {
		toggleMenu();
		isMobileMenuOpen((open) => !open);
		className("hamburger_close");
		navigate("/signup");
	};

	const handleLogout = async (e) => {
		e.preventDefault();
		const response = await authAxios.post("/api/auth/logout");
		console.log(response);
		dispatch(logout());
		toggleMenu();
		navigate("/signin");
	};

	const handleLogoutMobile = async (e) => {
		e.preventDefault();
		const response = await authAxios.post("/api/auth/logout");
		console.log(response);
		dispatch(logout());
		toggleMenu();
		isMobileMenuOpen((open) => !open);
		className("hamburger_close");
		navigate("/signin");
	};

	return (
		<div
			ref={dropdownRef}
			className="profile_menu"
		>
			<button
				onClick={() => navigate(ROUTES.DASHBOARD)}
				className="drop_down_profile profile_btn"
			>
				<img
					src={
						role === "admin"
							? adminAvatar
							: gender === "male"
							? malerAvatar
							: femaleAvatar
					}
					width={32}
					height={32}
					className="profile_img"
					alt="avatar"
				/>
				{isMobile && (
					<span className="profile_name">
						{firstname} {lastname}
					</span>
				)}
			</button>

			{isOpen && !isMobile && (
				<div className="drop_down_menu">
					<span onClick={handleProfile}>Profile </span>
					{role === "admin" && (
						<>
							<span onClick={handleUsers}>Users </span>
							<span onClick={handleAddUser}>Add User</span>
						</>
					)}
					<span onClick={handleLogout}>Logout</span>
				</div>
			)}
			{/* {isOpen && isMobile && (
				<div className="drop_down_menu_mobile">
					<span onClick={handleProfileMobile}>Profile </span>
					{role === "admin" && (
						<>
							<span onClick={handleUsersMobile}>Users </span>
							<span onClick={handleAddUserMobile}>Add User</span>
						</>
					)}
				</div>
			)} */}
		</div>
	);
};

export default ProfileMenu;
